var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59.5,
    fill: "#F6F9FF",
    stroke: "url(#paint0_linear_771_635)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.015 32.6161C53.5795 33.3656 50.1994 36.2368 49.0102 38.5667C44.664 47.0802 50.5488 56.8943 60 56.8943C71.5925 56.8943 76.8146 42.7499 68.0638 35.0528C64.7675 32.1535 60.3919 31.2687 56.015 32.6161ZM54.7398 60.667C50.7719 61.72 47.6732 63.5155 44.6096 66.5357C40.3761 70.7101 38.0949 75.7492 38.0033 81.1317C37.9472 84.4073 38.5933 85.7735 40.846 87.1463C42.1737 87.9553 43.1749 88 60 88C76.8251 88 77.8263 87.9553 79.154 87.1463C81.4067 85.7735 82.0528 84.4073 81.9967 81.1317C81.9051 75.7492 79.6239 70.7101 75.3904 66.5357C69.7265 60.9517 61.9708 58.7476 54.7398 60.667Z",
    fill: "#393184"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_771_635",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BAD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon2);
export default __webpack_public_path__ + "static/media/user-icon-2.a458b5f0249c9951dee3fd85fdb7f424.svg";
export { ForwardRef as ReactComponent };